import Modal from 'react-modal';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    padding: 0,
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

import { useEnableDisableMutipleUsherMutation } from '@/generated/graphql';
import { ICoordinatorTable, ISelectedUsher } from '@/shared/interfaces';

import { Box, Button, Divider, Grid, List, ListItem, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { AiOutlineExclamationCircle } from 'react-icons/ai';
import DeleteIcon from '@mui/icons-material/Delete';
import { styled } from '@mui/material/styles';

interface ICoordinatorProp {
  selectedUshers: ISelectedUsher[];
  isOpen: boolean;
  openEvent: (open: boolean) => void;
  refetchData: () => void;
  isDisabled: boolean;
  setSelectedUshers: React.Dispatch<React.SetStateAction<ISelectedUsher[]>>;
}

const Demo = styled('div')(({ theme }) => ({
  backgroundColor: (theme.vars || theme).palette.background.paper,
  width: '300px',
  overflow: 'scroll',
  maxHeight: '200px',
}));

export function EnableDisableMultipleUshers(props: ICoordinatorProp) {
  const { selectedUshers, isOpen, openEvent, refetchData, isDisabled, setSelectedUshers } = props;

  const [enableDisableMutipleUsher] = useEnableDisableMutipleUsherMutation();

  const handleClose = () => openEvent(false);

  const toggle = () => {
    enableDisableMutipleUsher({
      variables: {
        input: {
          usherIds: selectedUshers.map((x) => x.id),
          status: isDisabled,
        },
      },
      onCompleted() {
        setSelectedUshers([]);
        refetchData();
      },
    });

    // enableDisableCoordinatorMutation({
    //   variables: {
    //     input: {
    //       id: datas?.id ?? '',
    //       isDisabled: trigger,
    //     },
    //   },
    //   onCompleted() {
    //     refetchData();
    //   },
    // });

    handleClose();
  };

  const deleteUsher = (id: string) => {
    if (selectedUshers.length === 1) {
      openEvent(false);
    }
    setSelectedUshers((prev) => prev.filter((x) => x.id !== id));
  };

  return (
    <>
      <Modal isOpen={isOpen} onRequestClose={handleClose} style={customStyles} contentLabel="Example Modal">
        <Box sx={{ width: 500, py: 5, background: '#fff' }}>
          <Box justifyContent={'center'} display={'flex'} mb={3}>
            <AiOutlineExclamationCircle size={90} color={'#facea8'} />
          </Box>
          <Typography variant="h5" gutterBottom component="div" fontSize={30} fontWeight={600} textAlign={'center'}>
            Are you sure ?
          </Typography>

          <Typography variant="body1" gutterBottom textAlign={'center'}>
            {isDisabled ? <>You want to disable this ushers?</> : <>You want to enable this ushers?</>}
          </Typography>

          <Stack direction={'row'} justifyContent={'center'}>
            <Demo>
              <List dense={true}>
                {selectedUshers.map((x) => (
                  <ListItem>
                    <ListItemIcon sx={{ cursor: 'pointer' }} onClick={() => deleteUsher(x.id)}>
                      <DeleteIcon />
                    </ListItemIcon>
                    <ListItemText primary={`${x.uniqueCode} ${x.name}`} />
                  </ListItem>
                ))}
              </List>
            </Demo>
          </Stack>

          <Box justifyContent={'center'} display={'flex'} mt={5}>
            <Button
              variant="contained"
              sx={{ mr: 3, background: '#427FC1' }}
              onClick={() => {
                toggle();
              }}>
              Yes
            </Button>
            <Button variant="contained" sx={{ mr: 3, background: '#B44F4F' }}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
